import { MessageModel } from '$store/models';

const KEY_PREFIX = 'unsent_msg_';

type PeerMap = Record<string, MessageModel>;
type Store = Record<string, PeerMap>;

function keyFor(userId: number) {
  return `${KEY_PREFIX}${userId}`;
}

function read(userId: number): Store {
  try {
    return JSON.parse(localStorage.getItem(keyFor(userId)) || '{}') || {};
  } catch {
    return {};
  }
}

function write(userId: number, store: Store) {
  try {
    localStorage.setItem(keyFor(userId), JSON.stringify(store));
  } catch {}
}

export function saveUnsentMessage(userId: number, peerId: number, message: MessageModel) {
  const store = read(userId);
  store[peerId] = { ...(store[peerId] || {}), [message.id]: message };
  write(userId, store);
}

export function removeUnsentMessage(userId: number, peerId: number, messageId: number) {
  const store = read(userId);
  const peerMap = store[peerId];
  if (!peerMap || !(messageId in peerMap)) {
    return;
  }
  delete peerMap[messageId];
  if (!Object.keys(peerMap).length) {
    delete store[peerId];
  }
  write(userId, store);
}

export function getUnsentMessages(userId: number, peerId: number): PeerMap {
  return read(userId)[peerId] || {};
}

export function getMinUnsentMessageId(userId: number): number {
  const store = read(userId);
  let min = 0;
  for (const peerId in store) {
    for (const id in store[peerId]) {
      const num = Number(id);
      if (num < min) {
        min = num;
      }
    }
  }
  return min;
}
